import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/hebeidaxue/leftarrow.png';
import _imports_1 from '@/assets/hebeidaxue/rightarrow.png';
const _hoisted_1 = {
  class: "pagination-container"
};
const _hoisted_2 = ["disabled"];
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["disabled"];
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
  class: "page-info"
};
const _hoisted_8 = {
  class: "total"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
    class: "pagination-btn last",
    disabled: $props.currentPage === 1,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goToFirstPage && $options.goToFirstPage(...args))
  }, " 首页 ", 8, _hoisted_2), _createElementVNode("button", {
    class: "pagination-btn larrow",
    disabled: $props.currentPage === 1,
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goToPrevPage && $options.goToPrevPage(...args))
  }, [...(_cache[4] || (_cache[4] = [_createElementVNode("img", {
    src: _imports_0
  }, null, -1)]))], 8, _hoisted_3), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visiblePages, page => {
    return _openBlock(), _createElementBlock("button", {
      key: page,
      class: _normalizeClass(["pagination-btn rarrow", {
        'active': page === $props.currentPage
      }]),
      onClick: $event => $options.handlePageClick(page)
    }, _toDisplayString(page), 11, _hoisted_4);
  }), 128)), _createElementVNode("button", {
    class: "pagination-btn rarrow",
    disabled: $props.currentPage === $props.totalPages,
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goToNextPage && $options.goToNextPage(...args))
  }, [...(_cache[5] || (_cache[5] = [_createElementVNode("img", {
    src: _imports_1
  }, null, -1)]))], 8, _hoisted_5), _createElementVNode("button", {
    class: "pagination-btn last",
    disabled: $props.currentPage === $props.totalPages,
    onClick: _cache[3] || (_cache[3] = (...args) => $options.goToLastPage && $options.goToLastPage(...args))
  }, " 尾页 ", 8, _hoisted_6), _createElementVNode("span", _hoisted_7, [_cache[6] || (_cache[6] = _createTextVNode("当前共有 ", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString($props.totalPages), 1), _cache[7] || (_cache[7] = _createTextVNode(" 页", -1))])]);
}